/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Faster_TiInputs */

const en_funnel_ob_ben_faster_ti = /** @type {(inputs: Funnel_Ob_Ben_Faster_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You finish 2 to 3x faster by listening.`)
};

const es_funnel_ob_ben_faster_ti = /** @type {(inputs: Funnel_Ob_Ben_Faster_TiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchando terminas 2 o 3 veces más rápido.`)
};

/**
* | output |
* | --- |
* | "You finish 2 to 3x faster by listening." |
*
* @param {Funnel_Ob_Ben_Faster_TiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_faster_ti = /** @type {((inputs?: Funnel_Ob_Ben_Faster_TiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Faster_TiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_faster_ti(inputs)
	return en_funnel_ob_ben_faster_ti(inputs)
});